import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  const winDownload         = "https://glados.rocks/tools/Clash.for.Windows.Setup.exe";
  const clashDownload       = "https://glados.rocks/tools/cfa-2.5.9-premium-universal-release.apk";
  const macDownload         = "https://glados.rocks/tools/ClashX.dmg";

  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";
  var subscribe_endpoint = "update.glados-config.com";
  var alt_subscribe_endpoint = "www.glados-config.com";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`) + "#Github.com/GLaDOS-network";
  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const altsub           = `https://${alt_subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`

  const ipv6             = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-ipv6.yaml`
  const padavan_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-padavan.yaml`
  const android_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-android.yaml`
  const koolshare_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/koolshare.yaml`
  const openclash_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-openclash.yaml`
  const clash_restrict_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.restrict.yaml`

  var panes = [{
      desktop:true,
      menuItem:<Menu.Item key='pro3422'>
        Desktop GUI
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p>Clash for Windows 支持桌面Linux, 使用上与稍有不同，请按照以下方式运行:</p>
          <p>1. 下载客户端: <a href="/tools/Clash.for.Windows-0.20.4-x64-linux.tar.gz">X86</a>/<a href="/tools/Clash.for.Windows-0.20.4-arm64-linux.tar.gz">ARM</a></p>
          <p>2. 解压后，点击CFW运行Clash</p>
          <p>3. 点击Profile, 输入订阅地址:
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
            <Label>{suburl}</Label> 并点击Download, 选中新配置文件
          </p>
          <p>4. 使用Clash有两种方式:</p>
          <p><b>4.1 TUN 方式:</b></p>
          <p>4.1.1 打开Clash的主界面，点击Service Mode, 点击安装</p>
          <p>4.1.2 重启Clash，确认 Service Mode 右边的图标为绿色</p>
          <p>4.1.3 点击 TUN MODE，打开浏览器确认，系统配置完成。</p>
          <p>4.1.4 如果需要关闭，点击 TUN MODE 关闭即可。</p>
          <p><b>4.2 系统代理方式:</b></p>
          <p>4.2.1 打开Clash的主界面，查看Port右边的端口号X。</p>
          <p>4.2.2 打开系统的网络选项，选择网络代理，设置为手动模式，Socks 地址为127.0.0.1 端口设置为上一步的端口号X。</p>
          <p>4.2.3 打开浏览器确认，系统配置完成。</p>
          <p>4.2.4 如果需要关闭，选择网络代理，设置为关闭。</p>
        </Tab.Pane>)
      }
    },{
      desktop:true,
      menuItem:<Menu.Item key='pro3422'>
        Server Shell
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
        </Tab.Pane>)
      }
    },{
      desktop:true,
      menuItem:<Menu.Item key='pro3422'>
        Windows Subsystem for Linux
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
        </Tab.Pane>)
      }
    }


  ]

  const [clipboard,setClipboard] = useState(false);

  useEffect(()=>{
    if(clipboard == true){
      setTimeout(()=>{
        setClipboard(false)
      },3000)
    }
  },[clipboard])

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.clash.title")}
      <Header.Subheader>
      {t("settings.clash.notes")}
      </Header.Subheader>
    </Header>
    <p>{t("settings.clash.what")}</p>
    <p>{t("settings.clash.steps")}</p>
    <p>1.{t("settings.clash.step1")}</p>
    <p>2.{t("settings.clash.step2")}</p>
    <p>3.{t("settings.clash.step3")}</p>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            {t("settings.clash.tab.title")}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>
          <Tab  menu={{ color:"blue", secondary: true}} panes={panes} />
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
